<!-- start of Quick search filter -->
<div class="col-lg-12 nopadding">
  <app-quick-search [DefaultFilterArray]="DefaultFilterArray" [QuickSearchFilterArray]="quickFilterArray"
    [FilterFieldDefaultValues]="filterFieldDefaultValues" (updateDefaultArray)="updateDefaultArray($event)"
    (clearQuickSearch)="clearQuickSearch($event)"></app-quick-search>
</div>
<!-- end of Quick search filter -->
<!--Filter Code  -->
<div class="col-lg-12 nopadding">
  <div class="col-lg-8 d-flex align-item-center nopadding">
  <app-filter-panel [GridColumns]="GridColumns" [DefaultFilterArray]="DefaultFilterArray"
    (FilterEvent)="FilterApplyFilterEvent($event)" (FilterEventClearSymbol)="FilterEventClearSymbol($event)"
    (FilterEventClearCode)="FilterEventClearCode($event)" [isDatefilterDropdown]="true" [pageName]="'Comparative-Review-Report'">
  </app-filter-panel>
</div>


   <!-- Comments -->
  <div class="col-lg-4 pd-t-4 nopadding">
    <ng-container>
   <label for="browseCommentLabel" id="browseCommentLabel" class="floatRight">
     <p-button id="commentBtn" type="button" class="commentBtn" 
     [ngClass]="'button btn-xs non-active-symbol'" 
     (onClick)="onBrowsecomCommentViewer()">
       Browse Review Comments
     </p-button>
      <span class="btnBadge">{{this.commentViewerService.browseCommentViewerTotalCount}}</span>
   </label>        
 </ng-container>
 <ng-container>
 </ng-container>

</div>
<!-- End of Comments -->
</div>

<!-- Filter Quick Fields Panel Code -->
<div class="col-lg-12 nopadding">
  <app-symbol-panel [SymbolArray]="SymbolsArray" [CodeBlockArray]="CodesArray" [isDisplayCodeBlock]="true"
    [ResetLabel]="resetLabel" [rowCount]="totalRecords" [rowCountSymbol]="totalRecords"
    (ActiveSymbolEvent)="onActiveSymbolEvent($event)" (ActiveCodeEvent)="onActiveCodeEvent($event)">
  </app-symbol-panel>
</div>

<!--Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isDataLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
  }
  <p-table #dt [value]="dataset1" [columns]="cols" [resizableColumns]="true" [lazy]="true" (onPage)="changePage($event)"
    [sortOrder]="constantService.DEFAULT_SORDORDER_ASC" [(selection)]="selectedRow" [paginator]="true"
    selectionMode="multiple" appendTo="body" (onSort)="sort($event)" alwaysShowPaginator="true" paginatorPosition="both"
    showCurrentPageReport="true" [rows]="constantService.DEFAULT_ROWSIZE" [totalRecords]="totalRecords"
    [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS" sortMode="multiple" [rowsPerPageOptions]="rowsPerPageOptions"
    [scrollable]="true" scrollHeight="60vh" styleClass="comparative-review-table">
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          {{constantService.NO_RECORDFOUND_MSG}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th id="tableHeaderCheckbox" style="width: 3em">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        @for(col of columns; track col.field + '-'+ $index) {
        <th id="columns" pResizableColumn [pSortableColumn]="col.field"
          [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
          {{col.header}}
          @if((col.header | lowercase) !== 'action'){
          <p-sortIcon [field]="col.field"></p-sortIcon>
          }
        </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex"
        [ngClass]="(row['modifiedFlag'] | lowercase)== 'u' ? 'ui-widget-updated-row' : (row['modifiedFlag'] | lowercase) == 'd' ? 'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row'">
        <td style="width: 3em;padding-left: 6px !important;">
          <p-tableCheckbox [id]="'checkbox'+ rowIndex" [value]="row"
            (onClick)="$event.stopPropagation()"></p-tableCheckbox>
        </td>
        @for(col of columns; track col.field + '-'+ $index) {
        <td class="ui-resizable-column" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
          <!-- set String -->
          @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float' && col.header !=='OrderID' &&
          col.header !=='Status'){
          <span>
            {{row[col.field]}}
          </span>
          }
          @if( col.header ==='Status'){
          <span>
            {{(row[col.field]) | uppercase}}
          </span>
          }
          @if(col.header ==='OrderID'){
          <span>
            <a class="ordertID-able-link" matTooltip="View Order Details" [matTooltipShowDelay]="1000" appendTo="body"
              [id]="'OrderID'+ rowIndex" (click)="onRowSelect('OrderID',rowIndex,row)"
              style="color: blue;cursor: pointer">{{row[col.field]}}</a>
          </span>
          }
          @if(col.header ==='Action'){
          <span>
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye"
              (onClick)="onRowSelect('View',rowIndex,row);"></p-button>
            <p-button class="pi pi-xxx treeViewTcon" or class="fa fa-xxx treeViewTcon"
              matTooltip="Parent/Child Event Tree" [matTooltipShowDelay]="1000" matTooltipPosition="above"
              appendTo="body" icon="fa fa-fw fa-tree" [id]="'tree'+ rowIndex" (onClick)="onEventTree(row);"></p-button>
            <p-button class="pi pi-xxx commentIcon" or class="fa fa-xxx commentIcon" matTooltip="Add Comment"
              [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-comment"
              [id]="'comment'+ rowIndex" (onClick)="onRowSelect('Comment',rowIndex,row);"></p-button>
          </span>
          }
        </td>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <app-export-to-csv [gridColumns]="GridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
      Total Records: {{dataset1.length == 0? 0 : totalRecords}}

    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <!-- Page No : {{pageNumber }} -->
      Showing {{dataset1.length == 0? 0 : startLimit + 1}} to {{dataset1.length
      < rowcount ? dataset1.length < startLimit ? endLimit : dataset1.length : endLimit}} entries </ng-template>
  </p-table>
</div>

@if(edit){
<app-comp-review-view-details [screenType]="'comparativeReviewException'" (closeDialog)="closeAllDialogs($event)"
  [rowData]="rowDataforDialog" [index]="rowIndexForDialog" [correctCodeLength]="correctCodeLength" [value]="actionType">
</app-comp-review-view-details>}

@if(isDisplayCommentDialog){
  <app-comment-viewer 
  [pageName]="compReviewServiceService.pageName" 
  [isOpenCommentViewer]="isDisplayCommentDialog"
  [isDisplayAddCommentForm]="isDisplayAddCommentForm"
  [isDisplayDateRangeFilter]="false"
  [gridColumnsJSON]="queryCommentGridColumns" [selectedRow]="selectedRow"
  [commentStaticFilters]="commentStaticFilters" [commentAPIDetail]="commentAPIDetail"
  (closeCommentDialog)="closeAllDialogs('false');this.getBrowseCommentViewerCount()">
</app-comment-viewer>
}


@if(isDisplayEventTreeDialog){
<app-event-tree-dialog id="comp-sample-child-event-tree" [SelectedRow]="selectedRow"
  [isTreeOpen]="isDisplayEventTreeDialog" [pageName]="ApplicationName" (closeDialog)="closeAllDialogs($event)">
</app-event-tree-dialog>
}